<template>
  <!-- Items -->
  <ol>
    <template v-for="(item, i) in itemGroups">
      <li v-if="item && item.value && item.title" :key="`ListInputItem${i}`" class="i-l__item">
        <!-- Select item -->
        <b-select
          class="gp-button"
          :title="item.title"
          :selected="isItemSelected(item.value)"
          @click="toggleSelectItem(item.value)"
        />
      </li>
    </template>
  </ol>
</template>

<script>
import InputMixin from '../../../mixins/input'
import SelectButton from '@/components/button/selectButton'

export default {
  components: {
    'b-select': SelectButton,
  },
  methods: {
    /**
     * Get index of provided item
     * in list of selected items
     * @returns {number}
     */
    getItemSelectedIndex(item) {
      // If item provided,
      // get its index in selected list
      // using provided matcher function
      if (item) {
        return this.inputValue.findIndex((selected) => this.matcher(selected, item))
      }
      return -1
    },
    /**
     * Whether provided item is selected
     */
    isItemSelected(item) {
      return this.getItemSelectedIndex(item) >= 0
    },

    /**
     * Toggle selection state of
     * provided item and its group
     * @param {number} groupIndex
     */
    toggleSelectItem(item) {
      const selectedIndex = this.getItemSelectedIndex(item)
      if (selectedIndex >= 0) {
        // Remove item if already in list, and
        this.inputValue.splice(selectedIndex, 1)
      } else {
        // Add item to list if not in list, and
        this.inputValue.push(item)
      }
    },
  },
  mixins: [InputMixin],
  props: {
    /**
     * Select item groups
     */
    itemGroups: {
      default: () => [],
      type: Array,
    },

    /**
     * Function for matching selected item
     * against list item
     */
    matcher: {
      default: (a, b) => a === b,
      type: Function,
    },

    /**
     * Default input value
     */
    value: {
      default: () => [],
      type: Array,
    },
  },
}
</script>

<style lang="postcss" scoped>
.b {
  @apply shadow-none;
  &:before {
    @apply rounded-none;
  }
  &:after {
    @apply rounded-none;
  }
}

.gp-button {
  @apply text-black whitespace-normal;
}

li:not(:last-child) {
  @apply border-b border-solid border-grey-200;
}

.b.b--select {
  min-height: 3rem;
}

@screen desktop {
  .b.b--select >>> .b__tick {
    @apply w-b-sm h-b-sm;
  }
}
</style>
